import { faFileArrowUp } from '@fortawesome/pro-regular-svg-icons';
import { Button } from 'components';
import styles from './UploadInvoiceButton.module.scss';
import { useNavigation } from 'hooks';

export default function UploadInvoiceButton() {
    const { navigateToUploadInvoice } = useNavigation();

    return (
        <Button 
            className={styles.button}
            iconDefinition={faFileArrowUp}
            fillMode='flat'
            themeColor='secondary'
            onClick={navigateToUploadInvoice}
        >
            Upload Invoice
        </Button>
    )
}
